/**
 * @file 直播场次统计页面
 */
<template>
  <div>
    <div class="p-business-usage">
      <div class="p-business-usage-search">
        <plv-condition-filter v-model="conditionFilter" @search="getStatisticsSummary">
          <plv-condition-filter-item label="账期">
            <el-date-picker
              v-model="conditionFilter.dateRange"
              value-format="timestamp"
              size="small"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :picker-options="{
                disabledDate: filterDisabledMonth,
                onPick: onMonthPicker
              }"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
            />
          </plv-condition-filter-item>
          <plv-condition-filter-item
            label="分账号"
            :width="200"
            type="input"
            prop="email"
            placeholder="请输入分账号"
          />
          <plv-condition-filter-item label="频道号" width="160px">
            <plv-input
              v-model="conditionFilter.channelId"
              size="small"
              v-bind="channelInputOption"
              @change="onChangeChannel"
            />
          </plv-condition-filter-item>
          <plv-condition-filter-item type="search" search-label="查询" />
        </plv-condition-filter>
        <div class="p-live-broadcast-statistics-export">
          <plv-button @click="exportSessionData">导出数据</plv-button>
        </div>
      </div>

      <!-- 数据列表展示 -->
      <plv-table :data-source.sync="dataSource" @pageDataChange="getStatisticsSummary">
        <plv-table-column title="账期" prop="channelCreatedTime" width="100px">
          <span slot-scope="scope">
            {{ scope.rowData.startTime | formatDate('yyyy-MM') }}
          </span>
        </plv-table-column>
        <plv-table-column title="分账号" prop="email" width="100px" />
        <plv-table-column title="频道号" prop="channelId" width="100px" />
        <plv-table-column title="场次号" prop="sessionId" width="100px" />
        <plv-table-column title="场次名称" prop="name" width="100px" />
        <plv-table-column title="开始时间" prop="startTime" width="100px">
          <span slot-scope="scope">
            {{ scope.rowData.startTime | formatDate('yyyy-MM-dd HH:mm:ss') }}
          </span>
        </plv-table-column>
        <plv-table-column title="开播时长" prop="startDuration" width="100px">
          <span slot-scope="scope">
            {{ scope.rowData.startDuration | formatDuration }}
          </span>
        </plv-table-column>
        <plv-table-column title="直播观看人数" prop="uniqueViewer" width="100px" />
        <plv-table-column title="直播观看总时长（分）" prop="totalPlayDuration" width="150px">
          <span slot-scope="scope">
            {{ scope.rowData.totalPlayDuration }}
          </span>
        </plv-table-column>
        <plv-table-column title="最高同时在线" prop="maxConcurrencyCount" width="100px" />
        <plv-table-column
          title="回放时长（分）"
          prop="playDuration"
          width="100px"
          header-tips="回放时长为累计回放分钟数汇总，仅记录直播完后90天内回放记录"
        >
          <span slot-scope="scope">
            {{ scope.rowData.playDuration }}
          </span>
        </plv-table-column>
        <plv-table-column
          title="回放人数"
          prop="viewerCount"
          width="100px"
          header-tips="回放人数为观看次数针对userid和时间去重，如果一个人连续2天都有观看，记为1次"
        />
      </plv-table>
    </div>
  </div>
</template>

<script>
import billMixin from '@/mixins/bill';
import { dataExportMixin } from '@/mixins/data-export';
export default {
  mixins: [billMixin, dataExportMixin],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    // 频道输入框参数
    channelInputOption() {
      return {
        placeholder: '请输入频道',
        maxlength: 9,
        showLengthLimit: true,
        enLength: 1
      };
    },
  },
  methods: {
    onChangeChannel(val) {
      // 过滤非中文, 避免查询异常
      this.conditionFilter.channelId = Number(val.replace(/[^0-9]/gi, ''));
      if (+val === 0) {
        this.conditionFilter.channelId = null;
      }
    },
    async getStatisticsSummary({ pageSize, pageNumber }) {
      const params = this.getSearchParams();
      if (!params.email && !params.channelId) {
        this.$toast.error('请输入分账号或频道号');
        return;
      }
      params.pageSize = pageSize;
      params.pageNumber = pageNumber;
      try {
        const res = await this.$store.dispatch('account/getStatisticsSummary', params);
        this.dataSource.contents = res.contents;
        this.dataSource.pageNumber = res.pageNumber;
        this.dataSource.pageSize = res.pageSize;
        this.dataSource.totalItems = res.totalItems;
      } catch (error) {
        this.$toast.error('查询失败');
      }
    },
    exportSessionData() {
      const params = this.getSearchParams();
      this.asyncDownload(this.liveBroadcastStatisticsRecordExportTaskName, () => {
        return this.$store.dispatch('account/exportstaticsDetail', params);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.p-business-usage {
  padding: 0 18px;

  .p-live-broadcast-statistics-export {
    margin-bottom: 20px;
  }
}
</style>
